import { ITabsLayout, LayoutType } from '@components/layout';
import { MAIN_THEME } from '@styles';

export const createPolicyDetailsTabs = (policyType: string): ITabsLayout => {
  return {
    typeLogicalId: LayoutType.tabslayout,
    leftColumn: {
      backgroundColor: MAIN_THEME.color.white,
      collapsable: false,
      width: 2,
      collapsed: false
    },
    mainColumn: {
      backgroundColor: MAIN_THEME.color.white98,
      collapsable: false,
      width: 10,
      collapsed: false
    },
    rightColumn: {
      backgroundColor: MAIN_THEME.color.white,
      collapsable: false,
      width: 0,
      collapsed: false
    },
    tabs: [
      {
        name: 'summary',
        title: 'Summary',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}]
      },
      {
        name: 'policyPersons',
        title: 'Policy Persons',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}]
      },
      {
        name: 'commissionSplit',
        title: 'Commission Split',
        iconUrl: '',
        widgets: [{}]
      },
      {
        name: 'policyDocuments',
        title: 'Documents',
        iconUrl: '/icons/folder-primary.svg',
        widgets: [{}]
      },
      {
        name: 'paymentTerms',
        title: 'Payments',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}]
      },
      {
        name: 'amendments',
        title: 'Amendments',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}]
      },
      {
        name: 'distribution',
        title: 'Distribution',
        iconUrl: '/icons/file-summary-primary.svg',
        widgets: [{}],
        hidden: policyType === 'GROUP'
      }
    ]
  };
};
